// import Unauthenticated from 'Components/Layouts/Default/Unauthenticated';
// import Authenticated from 'Components/Layouts/Default/Authenticated';
// import SettingsLayout from 'Components/Layouts/Default/SettingsLayout';
// import AuthLayout from 'Components/Layouts/Default/AuthLayout';

import Unauthenticated from 'Components/Layouts/TopMenu/Unauthenticated';
import Authenticated from 'Components/Layouts/TopMenu/Authenticated';
import SettingsLayout from 'Components/Layouts/TopMenu/SettingsLayout';
import AuthLayout from 'Components/Layouts/TopMenu/AuthLayout';

// We comment out the un-used layouts to minimize the build size.

export default {
    /*
    |--------------------------------------------------------------------------
    | Site Layout
    |--------------------------------------------------------------------------
    |
    | 'site_layout' options; 'default', 'top-menu'
    |
    */

    'site_layout': 'top-menu',

    'site_layout_files': {
        'unauthenticated': Unauthenticated,
        'authenticated': Authenticated,
        'settings_layout': Authenticated,
        'auth_layout': AuthLayout
    },
};
